export default function Error() {
  return (
    <div className='dt:w-350px mb:w-full px-4 py-12 mt-12 mx-auto text-center font-Josefin-bold bg-l-94'>
      <span className=' inline-block mb-4 text-xl'>
        An internal error has occured.
      </span>
      <br />
      <span>
        Our team is looking into it.
      </span>
      <br />
    </div>
  )
}
